import { load } from 'recaptcha-v3'

const CAPTCHA_ACTION = 'send_document_by_email'

export const getSendAsEmailCaptchaToken = async (): Promise<string | null> => {
  const isCaptchaEnabled = window.ENV.ZERVANT_GOOGLE_CAPTCHA_ENABLED === true
  const captchaSiteKey = window.ENV.ZERVANT_GOOGLE_CAPTCHA_SITEKEY

  if (!isCaptchaEnabled || !captchaSiteKey) {
    return null
  }

  try {
    const reCaptcha = await load(captchaSiteKey)
    return reCaptcha.execute(CAPTCHA_ACTION)
  } catch {
    return null
  }
}
